"use strict";

/**
 * Formats result dates as either an ISO date or date-time, based on includeTime.
 */
const getOutputDates = (result, props) => {
  const { startDate, endDate } = result;
  const { includeTime, inclusiveEndDate, mode } = props;

  if (!includeTime) {
    // If endDate is exclusive (default) and it's a rolling end date, move endDate to start of next day
    if (!inclusiveEndDate && ["since", "rolling"].includes(mode)) {
      return {
        ...result,
        startDate: startDate.startOf("day").setZone("Etc/UTC").toISODate(),
        endDate: endDate
          .plus({
            days: 1
          })
          .startOf("day")
          .setZone("Etc/UTC")
          .toISODate()
      };
    }

    return {
      ...result,
      startDate: startDate.startOf("day").setZone("Etc/UTC").toISODate(),
      endDate: endDate.startOf("day").setZone("Etc/UTC").toISODate()
    };
  }

  return {
    ...result,
    startDate: startDate.setZone("Etc/UTC").toISO(),
    endDate: endDate.setZone("Etc/UTC").toISO()
  };
};

module.exports = getOutputDates;
